var map = {
	"./music-instructions.json": 4523,
	"./music-library-intro2024.json": 4524,
	"./music-library-launch2024.json": 4525,
	"./music-progression.json": 4526,
	"./startSourcesAdvanced.json": 4527,
	"./startSourcesSimple.json": 4528,
	"./startSourcesSimple2.json": 4529,
	"./startSourcesTracks.json": 4530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4260;